<style lang="scss">
  @import "@/assets/scss/vuexy/pages/Grid.scss";
</style>

<template>
    <div>
    <div class="vx-row">
      <div class="vx-col w-full my-2">
        <vs-button  @click="showFilters = !showFilters"  type="flat" color="grey" class="float-right hover:text-white">
          <iconBase iconName="filter_asc" :width="18" :height="18" iconColor="#626262" class="align-middle mr-2"><iconFilter/></iconBase>
          <span v-show="!showFilters"  class="font-bold">{{$t('Labels.ShowFilters')}}</span>
          <span v-show="showFilters"  class="font-bold">{{$t('Labels.HideFilters')}}</span>
        </vs-button>
      </div>
    </div>
    <div class="vx-row px-2 py-5" v-show="showFilters">
      <div class="vx-col w-full my-2 sm:w-auto sm:my-0">
        <label class="font-bold">{{$t('Labels.Alias')}}</label>
        <vs-input class="w-full" v-model="filters.alias" />
      </div>
      <div class="vx-col w-full my-2 sm:w-auto sm:my-0">
        <label class="font-bold">{{$t('Labels.Status')}}</label>
        <v-select class="align-middle" :options="state_values" v-model="filters.status" :reduce="v => v.value"  :clearable="false"/>
      </div>
      <div class="vx-col w-full my-2 sm:w-auto sm:my-0">
        <label class="font-bold">{{$t('Labels.Size')}}</label>
        <v-select class="align-middle" :options="sizes" v-model="size" :reduce="v => v.value"  :clearable="false"/>
      </div>
      <div class="vx-col w-full text-center hidden sm:inline-block sm:w-auto">
        <vs-button @click="doFilter()" color="primary" class="mr-2 mt-6">{{$t('Labels.Filter')}}</vs-button>
        <vs-button @click="resetFilters()" color="danger" type="border" class="bg-white mt-6">{{$t('Labels.Clean')}}</vs-button>
      </div>
    </div>
    <div class="vx-row px-2 py-5" v-show="showFilters && size !== ''">
      <div class="vx-col w-full my-2 sm:w-auto sm:my-0">
        <label  class="font-bold">{{$t('Labels.Temperature')}}</label>
        <vs-slider v-model="filters.temp" :min="limits.temperature.min" :max="limits.temperature.max" text-fixed="°"/>
      </div>
      <div class="vx-col w-full my-2 sm:w-auto sm:my-0">
        <label  class="font-bold">{{$t('Labels.Flow')}}</label>
        <vs-slider v-model="filters.flow" :min="limits.flow.min" :max="limits.flow.max" text-fixed="ft3/h"/>
      </div>
      <div class="vx-col w-full my-2 sm:w-auto sm:my-0">
        <label  class="font-bold">{{$t('Labels.Pressure')}}</label>
        <vs-slider v-model="filters.pressure" :min="limits.pressure.min" :max="limits.pressure.max" text-fixed="Psi"/>
      </div>
    </div>

    <div class="vx-row mb-5">
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <label class="font-bold align-middle mr-2">{{$t('Labels.OrderBy')}}</label><v-select @input="getResponse" class="align-middle inline-block" :options="columnOrders" v-model="filters.byColumn" :reduce="v => v.value"  :clearable="false"/>
      </div>
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <vs-button size="small" @click="filterOrders('ASC')"  type="flat" color="grey" class="align-middle inline-block ml-2" :class="{'bg-primary': filters.byOrder == 'ASC'}">
          <iconBase iconName="filter_asc" :width="18" :height="18" iconColor="#626262" class="align-middle"><iconFilterAsc/></iconBase>
        </vs-button>
        <vs-button  size="small" @click="filterOrders('DESC')"  type="flat" color="grey" class="align-middle inline-block ml-2" :class="{'bg-primary': filters.byOrder != 'ASC'}">
          <iconBase iconName="filter_desc" :width="18" :height="18" iconColor="#626262" class="align-middle"><iconFilterDesc/></iconBase>
        </vs-button>
      </div>
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <label class="font-bold align-middle mr-2">{{$t('Labels.ByPage')}}</label><v-select @input="getResponse" class="align-middle inline-block" :options="byPage" v-model="filters.limit" :reduce="v => v.value"  :clearable="false"/>
      </div>
      <div class="vx-col w-full text-center my-2 sm:w-auto sm:my-0">
        <a v-if="urlDownload.length > 0" class="btn-primary align-middle" :href="urlDownload" download="Airflow.csv"><feather-icon icon="DownloadCloudIcon" /></a>
      </div>
    </div>
    <div class="grid-container">
        <div class="item-grid-view vx-row match-height mt-4 cursor-pointer">
            <div :key="item.objectID" @click="goToDetail(item.air_flow_id)" class="vx-col lg:w-1/4 sm:w-1/2 w-full" v-for="item in response">
                <vx-card class="grid-view-item mb-base overflow-hidden">
                    <gridPrincipalItem
                      img="airflow"
                      :name="item.alias"
                      :description="$t('Labels.Alias')"
                    ></gridPrincipalItem>
                    <vs-divider/>
                    <valueItem
                      :value="parseFloat(item.flow).toFixed(2)"
                      :description="$t('Labels.Flow')"
                      img="flow"
                      unit="ft3/h"
                    ></valueItem>
                    <valueItem
                      :value="parseFloat(item.temperature).toFixed(2)"
                      :description="$t('Labels.Temperature')"
                      img="temperature"
                      unit="°C"
                    ></valueItem>
                    <valueItem
                      :value="celsiusToFahrenheit(item.temperature)"
                      :description="$t('Labels.Temperature')"
                      img="temperature"
                      unit="°F"
                    ></valueItem>
                    <valueItem
                      :value="parseFloat(item.pressure).toFixed(2)"
                      :description="$t('Labels.Pressure')"
                      img="pressure"
                      unit="Psi"
                    ></valueItem>
                    <vs-divider/>
                    <valueItem
                      :value="item.updated_at.split(' ')[0]"
                      :description="item.updated_at.split(' ')[1]"
                      img="fecha"
                    ></valueItem>
                    <alertItem :status="item.status === 1? true: false"></alertItem>
                </vx-card>
            </div>
        </div>
        <vs-pagination :max="5" :total="totalPages" v-if="response" v-model="currentx">
        </vs-pagination>
    </div>
    </div>
</template>
<script>
import { request } from '@/request.js'
import { empty, celsiusToFahrenheit } from '@/helpers.js'
import vSelect from 'vue-select'
import gridPrincipalItem from '@/components/gridPrincipalItem/gridPrincipalItem.vue'
import valueItem from '@/components/valueItem/valueItem.vue'
import alertItem from '@/components/alertItem/alertItem.vue'
import iconBase from '@/components/icons/iconBase'
import iconFilterAsc from '@/components/icons/iconFilterAsc'
import iconFilterDesc from '@/components/icons/iconFilterDesc'
import iconFilter from '@/components/icons/iconFilter'

export default {
  components: {
    'v-select': vSelect,
    gridPrincipalItem,
    valueItem,
    alertItem,
    iconBase,
    iconFilterAsc,
    iconFilterDesc,
    iconFilter
  },
  data () {
    return {
      response: [],
      currentx: 1,
      totalPages: 0,
      state_values: [
        { label: 'Todos', value: '' },
        { label: 'Correcto', value: 0 },
        { label: 'Alerta', value: 1 }
      ],
      sizes: [
        { label: 'Todos', value: '' },
        { label: '1in', value: 1 },
        { label: '2in', value: 2 }
      ],
      filters: {
        limit: 20,
        offset: 0,
        byColumn: 'updated_at',
        byOrder: 'ASC',
        alias: '',
        max_flow: '',
        min_flow: '',
        max_temperature: '',
        min_temperature: '',
        max_pressure: '',
        min_pressure: '',
        status: '',
        temp: [0, 60],
        flow: [0, 100],
        pressure: [0, 100],
        size: ''
      },
      urlDownload: '',
      columnOrders: [
        { label: this.$t('Labels.Alias'), value: 'alias' },
        { label: this.$t('Labels.Status'), value: 'status' },
        { label: this.$t('Labels.Date'), value: 'updated_at' }
      ],
      byColumn: 'updated_at',
      byPage: [
        { label: 20, value: 20 },
        { label: 50, value: 50 },
        { label: 75, value: 75 },
        { label: 100, value: 100 }
      ],
      showFilters: false,
      limits: {
        flow: {
          min: 0,
          max: 0
        },
        pressure: {
          min: 0,
          max: 0
        },
        temperature: {
          min: 0,
          max: 0
        }
      },
      size: '',
      typesLimits: []
    }
  },

  methods: {
    async getResponse () {
      this.$vs.loading()

      if (this.limits.temperature.max !== 0) {
        this.filters.min_temperature = this.filters.temp[0]
        this.filters.max_temperature = this.filters.temp[1]
      }

      if (this.limits.flow.max !== 0) {
        this.filters.min_flow = this.filters.flow[0]
        this.filters.max_flow = this.filters.flow[1]
      }

      if (this.limits.pressure.max !== 0) {
        this.filters.min_pressure = this.filters.pressure[0]
        this.filters.max_pressure = this.filters.pressure[1]
      }

      this.filters.size = this.size

      const params = {
        url: 'modelo/airFlow',
        method: 'GET',
        params: this.filters
      }

      await request(params).then(response => {
        this.response = !empty(response.data.data.rows) ? response.data.data.rows : []
        if (!empty(response.data.limit_size_1)) { this.typesLimits.push(response.data.limit_size_1) }
        if (!empty(response.data.limit_size_2)) { this.typesLimits.push(response.data.limit_size_2) }
        this.setPages(!empty(response.data.data.count) ? response.data.data.count : 0)
        this.createCsv()
      }).catch(() => {
        this.response = []
        this.setPages(0)
      }).finally(() => {
        this.$vs.loading.close()
      })
    },

    goToDetail (uuid) {
      window.location.href = `/airflow/detail/${uuid}`
    },

    createCsv () {
      const csv = []
      const headers = []
      headers.push('Flujo')
      headers.push('Temperatura')
      headers.push('Presión')
      headers.push('Alias')
      headers.push('Fecha')
      headers.push('Alerta')
      csv.push(headers.join(','))
      this.response.map(item => {
        const row = []
        row.push(`${item.flow}ft3/h`)
        row.push(`${item.temperature}°C`)
        row.push(`${item.pressure}Pa`)
        row.push(item.alias)
        row.push(item.updated_at)
        row.push((item.status === 1 ? 'Alerta' : 'Correcto'))
        csv.push(row.join(','))
        return item
      })
      const file = csv.join('\n')
      const csvFile = new Blob([file], { type: 'text/csv' })
      this.urlDownload = window.URL.createObjectURL(csvFile)
    },
    filterOrders (param) {
      this.filters.byOrder = param
      this.getResponse()
    },
    setPages (total) {
      this.totalPages = Math.ceil(total / this.filters.limit)
    },
    resetFilters () {
      this.filters.status = ''
      this.filters.alias = ''
      this.filters.max_flow = ''
      this.filters.min_flow = ''
      this.filters.max_temperature = ''
      this.filters.min_temperature = ''
      this.filters.max_pressure = ''
      this.filters.min_pressure = ''
      this.filters.status = ''
      this.filters.temp[0] = this.limits.temperature.min
      this.filters.temp[1] = this.limits.temperature.max
      this.filters.flow[0] = this.limits.flow.min
      this.filters.flow[1] = this.limits.flow.max
      this.filters.pressure[0] = this.limits.pressure.min
      this.filters.pressure[1] = this.limits.pressure.max
      this.filters.size = ''
      this.size = ''
    },
    doFilter () {
      if (this.currentx !== 1) { this.currentx = 1 } else { this.getResponse() }
    },
    celsiusToFahrenheit (c) {
      return celsiusToFahrenheit(c)
    }

  },
  sockets: {
    airflow (payload) {
      this.response.forEach(toModify => {
        if (toModify.air_flow_id === payload.uuid) {
          toModify.pressure = payload.pressure
          toModify.flow = payload.flow
          toModify.temperature = payload.temperature
          toModify.status = payload.status
          toModify.updated_at = payload.updated_at
        }
      })
    }
  },
  created () {
    this.getResponse()
  },

  watch: {
    currentx (val) {
      this.filters.offset = (val - 1) * this.filters.limit
      this.getResponse()
    },
    byColumn (val) {
      this.filters.byColumn = val
      this.currentx = 1
    },
    size (val) {
      if (val !== '') {
        this.limits = this.typesLimits[val - 1]
        this.filters.temp[0] = this.limits.temperature.min
        this.filters.temp[1] = this.limits.temperature.max
        this.filters.flow[0] = this.limits.flow.min
        this.filters.flow[1] = this.limits.flow.max
        this.filters.pressure[0] = this.limits.pressure.min
        this.filters.pressure[1] = this.limits.pressure.max
      }
    }
  }
}
</script>
